"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
/**Spinner de cargando */
class Spinner extends React.Component {
    render() {
        return (React.createElement("svg", { width: "14", height: "14", viewBox: "0 0 14 14", stroke: "#000" },
            React.createElement("g", { fill: "none", fillRule: "evenodd" },
                React.createElement("g", { strokeWidth: "2" },
                    React.createElement("circle", { strokeOpacity: ".2", cx: "7", cy: "7", r: "6" }),
                    React.createElement("path", { d: "M 7 1 a 6 6 0 0 1 6 6" },
                        React.createElement("animateTransform", { attributeName: "transform", type: "rotate", from: "0 7 7", to: "360 7 7", dur: "0.5s", repeatCount: "indefinite" }))))));
    }
}
exports.Spinner = Spinner;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/spinner.js
// module id = 133
// module chunks = 0